import React from 'react'

const Notfound = () =>{
    return (
        <h1 className="text-center">Not Found</h1>
    )
}

export default Notfound